var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsDashboardGreetingHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21853",
    "data-name": "Group 21853",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.732,
    height: 15.19,
    viewBox: "0 0 16.732 15.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    width: 16.732,
    height: 15.19,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21852",
    "data-name": "Group 21852",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11196",
    "data-name": "Path 11196",
    d: "M80.317,12.07l-1.11-2.486a1.474,1.474,0,0,0-2.413-.419l-.17-.381a1.422,1.422,0,0,0-1.875-.719l-.1.045a1.411,1.411,0,0,0-.393.263,1.422,1.422,0,0,0-1.813-.6l-.1.045A1.421,1.421,0,0,0,71.621,9.7l.041.092a1.413,1.413,0,0,0-.438.116l-.1.045a1.419,1.419,0,0,0-.718,1.875l1.565,3.509a1.675,1.675,0,0,0-1.479,2.941,9.547,9.547,0,0,1,.875.848,10.921,10.921,0,0,0,2.811,2.6,5.365,5.365,0,0,0,2.772.824,5.089,5.089,0,0,0,2.154-.5,5.034,5.034,0,0,0,2.821-2.675,5.158,5.158,0,0,0-.088-3.977Zm.71,6.959a4.142,4.142,0,0,1-2.329,2.15c-2.179,1.01-4.334.141-6.589-2.656a11.713,11.713,0,0,0-1.033-1,.719.719,0,1,1,.859-1.152l2.366,1.66a.479.479,0,0,0,.55-.783l-1.432-1-2.142-4.8a.463.463,0,0,1,.234-.611l.1-.045a.463.463,0,0,1,.611.234L74,15a.479.479,0,1,0,.874-.39L72.5,9.307a.463.463,0,0,1,.234-.611l.1-.045a.463.463,0,0,1,.611.234L75.9,14.406a.479.479,0,1,0,.874-.39l-1.984-4.45a.462.462,0,0,1,.243-.582l.1-.045a.463.463,0,0,1,.611.234l2.158,4.84a.479.479,0,1,0,.874-.39s-1.369-3.166-1.4-3.228a.518.518,0,1,1,.947-.422l1.028,2.3,1.6,3.51a4.2,4.2,0,0,1,.067,3.241",
    transform: "translate(-67.092 -7.354)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11197",
    "data-name": "Path 11197",
    d: "M345.033.12a.478.478,0,0,0-.633.718,8.072,8.072,0,0,1,2.147,3.038.479.479,0,0,0,.889-.356,9.036,9.036,0,0,0-2.4-3.4",
    transform: "translate(-330.739 -0.001)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11198",
    "data-name": "Path 11198",
    d: "M1.166,82.48a.478.478,0,0,0-.615.283,8.97,8.97,0,0,0-.416,4.654.479.479,0,0,0,.471.4.491.491,0,0,0,.083-.007.479.479,0,0,0,.389-.554A8.009,8.009,0,0,1,1.449,83.1a.479.479,0,0,0-.283-.615",
    transform: "translate(0 -79.217)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsDashboardGreetingHand);
export default __webpack_public_path__ + "static/media/jobs-dashboard-greeting-hand.26672d41baaef2b33945e135b079bfe0.svg";
export { ForwardRef as ReactComponent };